module.exports = __webpack_public_path__ + "x3.no2.314219e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/x3.no2.jpg
// module id = JZoZ
// module chunks = 0